var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 81,
    viewBox: "0 0 54 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0008 81.0001C41.9129 81.0001 54.0015 79.8878 54.0015 78.5158C54.0015 77.1438 41.9129 76.0315 27.0008 76.0315C12.0887 76.0315 0 77.1438 0 78.5158C0 79.8878 12.0887 81.0001 27.0008 81.0001Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.136 33.6243H40.9472V21.2136C40.9472 13.4953 34.6905 7.21552 27.0008 7.21552C19.311 7.21552 13.0543 13.4953 13.0543 21.2136V33.6243H5.86548V21.2136C5.86548 9.51673 15.3471 0 27.0008 0C38.6544 0 48.136 9.51673 48.136 21.2136V33.6243Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.136 21.2137V33.6244H40.9471V30.3053C43.8227 29.1508 44.9729 26.8418 44.9729 23.667V21.2137C44.9729 10.0491 36.337 0.873708 25.4192 0.0590524C25.5351 0.0497421 25.6526 0.0435352 25.7701 0.0357765C25.7933 0.0357765 25.8165 0.0326731 25.8397 0.0311214C25.9216 0.0264662 26.0051 0.021811 26.0871 0.0202593C26.1195 0.0202593 26.1535 0.0171558 26.186 0.0156041C26.2324 0.0156041 26.2788 0.0109489 26.3267 0.0109489C26.4194 0.00629378 26.5107 0.00474205 26.6034 0.00319033C26.7364 8.68804e-05 26.8693 -0.00146484 27.0023 -0.00146484C38.6575 -0.00146484 48.1376 9.51371 48.1376 21.2122L48.136 21.2137Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5012 31.0266H4.50043C2.79278 31.0266 1.40845 32.4161 1.40845 34.1301V69.9175C1.40845 71.6315 2.79278 73.0209 4.50043 73.0209H49.5012C51.2089 73.0209 52.5932 71.6315 52.5932 69.9175V34.1301C52.5932 32.4161 51.2089 31.0266 49.5012 31.0266Z",
    fill: "#F1C400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.169 58.6411C32.3993 60.092 31.2831 61.4032 29.8206 61.4032H24.1793C22.7168 61.4032 21.6021 60.092 21.8309 58.6411L22.6333 53.5871C21.4259 52.4295 20.673 50.7987 20.673 48.9925C20.673 45.4856 23.5052 42.6428 26.9992 42.6428C30.4931 42.6428 33.3254 45.4856 33.3254 48.9925C33.3254 50.7987 32.574 52.4295 31.3651 53.5871L32.1674 58.6411H32.169Z",
    fill: "#B2841D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5932 33.9128V70.1347C52.5932 71.7299 51.3069 73.0209 49.7177 73.0209H12.9106C27.8635 73.0209 43.8228 70.5676 43.8228 53.2504V38.5307C43.8228 34.3861 40.4757 31.0266 36.3464 31.0266H49.7177C51.3069 31.0266 52.5932 32.3176 52.5932 33.9128Z",
    fill: "#D39B1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.85266 34.5739V53.8277C3.85266 53.8277 10.1804 38.1848 23.3043 33.48H4.94259C4.34119 33.48 3.85266 33.9703 3.85266 34.5739Z",
    fill: "#FFE36C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5372 49.3542C21.5372 51.1604 22.2886 52.7913 23.4975 53.9488L22.6952 59.0028C22.5421 59.9618 22.9796 60.8602 23.714 61.3583C22.4896 61.1163 21.6284 59.9338 21.8325 58.6428L22.6349 53.5888C21.4275 52.4313 20.6746 50.8004 20.6746 48.9942C20.6746 45.4873 23.5068 42.6445 27.0008 42.6445C28.0289 42.6445 29.0013 42.8913 29.8593 43.3288C29.2332 43.1178 28.5607 43.0061 27.8634 43.0061C24.3695 43.0061 21.5372 45.8488 21.5372 49.3557V49.3542Z",
    fill: "#936A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6875 1.5874C22.6875 1.5874 8.16597 4.39447 7.01575 20.2034H9.74752C9.74752 20.2034 10.3226 7.64533 22.6875 1.5874Z",
    fill: "#EFEFEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 81,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.4ed7043d68200612825a20acb48fc709.svg";
export { ForwardRef as ReactComponent };